import React from "react";
import FindJob from "../../views/FindJob";

const FindJobPage = () => {
  return <FindJob />;
};

export default FindJobPage;
